<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .contact-types-section {
    margin-top: utils.in_rem(16px);
  }

  .dropdown-container {
    max-width: 300px;
  }
</style>

<script>
  import MultiSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/MultiSelectDropdown/MultiSelectDropdown.svelte";
  import { integrationStore } from "../../../stores";

  export let providerTitle = "";
  export let contactTypeOptions = [];

  let selectedItems = $integrationStore.getValue("syncAs", "dataRefresh");

  // Transform contactTypeOptions into the format needed for the dropdown
  $: items = contactTypeOptions.map((opt) => ({
    id: opt.val,
    label: opt.key,
  }));

  $: $integrationStore.setValue("syncAs", selectedItems, "dataRefresh");
</script>

<div class="contact-types-section">
  <div class="dropdown-container">
    <MultiSelectDropdown
      label="Select {providerTitle} contact types to update"
      labelSize="large"
      class="contact-types-dropdown"
      {items}
      bind:selectedItems
      placeholder="Select contact types"
      showFilter={false}
    />
  </div>
</div>
